import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  payMyselfOptionTitle: {
    defaultMessage: 'Pay myself',
    id: '6Sy04Z',
    description: 'Payout type option title - Pay myself',
  },
  payMyCompanyOptionTitle: {
    defaultMessage: 'Pay my company',
    id: 'Ar+x4C',
    description: 'Payout type option title - Pay my company',
  },
  payoutTypeTitle: {
    defaultMessage: 'PAYOUT TYPE',
    id: 'MafFrv',
    description: 'PAYOUT TYPE field title',
  },
  ssnTitle: {
    defaultMessage: 'SOCIAL SECURITY NUMBER',
    id: 'us_ssn_title',
    description: 'US SSN field title',
  },
  ssnError: {
    defaultMessage: 'Enter 9 digits.',
    id: 'us_ssn_error',
    description: 'US SSN field error message',
  },
  legalNameTitle: {
    defaultMessage: 'LEGAL NAME',
    id: 'us_legal_name_title',
    description: 'US legal name field title',
  },
  dbaTitle: {
    defaultMessage: 'DBA, IF APPLICABLE',
    id: 'us_dba_title',
    description: 'US DBA field title',
  },
  legalAddressTitle: {
    defaultMessage: 'LEGAL ADDRESS',
    id: 'us_legal_address_title',
    description: 'US legal address field title',
  },
  zipCodeTitle: {
    defaultMessage: 'ZIP CODE',
    id: 'us_zip_code_title',
    description: 'US zip code field title',
  },
  cityTitle: {
    defaultMessage: 'CITY',
    id: 'us_city_title',
    description: 'US city field title',
  },
  tlcBaseAffiliationTitle: {
    defaultMessage: 'TLC BASE AFFILIATION NUMBER (OPTIONAL)',
    id: 'us_tlc_base_affiliation_title',
    description: 'US TLC base affiliation number field title',
  },
  einTitle: {
    defaultMessage: 'EIN',
    id: 'us_ein_title',
    description: 'US EIN field title',
  },
  einError: {
    defaultMessage: 'Enter 9 digits.',
    id: 'us_ein_error',
    description: 'US EIN field error message',
  },
});
